// vendor
import { Injectable } from '@angular/core';
import { Router, ActivationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { filter, map, tap } from 'rxjs/operators';
// store
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { GO, Go, BACK, FORWARD, Change } from '../actions/router.action';

@Injectable()
export class RouterEffects {
  constructor(
    private actions$: Actions,
    private router: Router,
    private location: Location,
    private store: Store<any>
  ) {
    this.listenToRouter();
  }

  navigate$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(GO),
        map((action: Go) => action.payload),
        tap(({ path, query: queryParams, extras }) => {
          this.router.navigate(path, { queryParams, ...extras });
        })
      ),
    { dispatch: false }
  );

  navigateBack$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(BACK),
        tap(() => this.location.back())
      ),
    { dispatch: false }
  );

  navigateForward$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(FORWARD),
        tap(() => this.location.forward())
      ),
    { dispatch: false }
  );

  /**
   * listen to router change
   */
  private listenToRouter() {
    this.router.events.pipe(filter((event) => event instanceof ActivationEnd)).subscribe((event: ActivationEnd) => {
      this.store.dispatch(
        new Change({
          params: { ...event.snapshot.params },
          path: event.snapshot.routeConfig.path,
        })
      );
    });
  }
}
